import React, { useState } from "react";
import "./sign-up.styles.scss";
import FormInput from "../../../general/form-input/form-input.component";
import Button from "../../../general/button/button.component";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import db from "../../../../firebase.config";
import { doc, setDoc } from "firebase/firestore";
var bcrypt = require("bcryptjs");

let globalUSN; //create a global variable to use as docRef in between sign-up
let globalPassword;

const SignUp = (props) => {
  let navigate = useNavigate();
  const [state, setState] = useState({ USN: "", password: "" });

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { USN, password } = state;
    globalUSN = USN;
    globalPassword = password;

    try {
      await setDoc(doc(db, "studentData", globalUSN), {
        USN: globalUSN,
        password: bcrypt.hashSync(globalPassword, 8),
        role: "student",
        hasUploadedResume: false,
      });
      console.log("Document written with ID: ", globalUSN);
    } catch (err) {
      console.error("Error adding document: ", err);
    }
    //push to db
    console.log(USN, password);
    setTimeout(() => {
      navigate(`..${buttonLink}`);
    }, 3000);
  };

  const handleChange = (e) => {
    const { value, name } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };

  const buttonLink = props.buttonLink.substring(
    props.buttonLink.lastIndexOf("/")
  );
  const secondText = props.secondSignText;
  console.log(buttonLink);

  return (
    <div className="sign-in">
      <Typography
        variant="h5"
        sx={{ fontFamily: "Montserrat" }}
        className="title"
      >
        {props.secondSignText}
      </Typography>
      <Typography variant="sub">Sign up with USN and password</Typography>
      <form onSubmit={handleSubmit}>
        <FormInput
          name="USN"
          type="text"
          value={state.USN}
          required
          onChange={handleChange}
          label="USN"
          placeholder="USN"
        />
        <FormInput
          name="password"
          type="password"
          value={state.password}
          required
          onChange={handleChange}
          label="Password"
          placeholder="Password"
        />
        <Button type="submit" onClick={handleSubmit} buttonLink={buttonLink}>
          Sign up
        </Button>
      </form>
    </div>
  );

  //{props.secondSignText.indexOf('Placement')===-1?'up':'in'} will check if the string Placement exists in the passed prop. For facultyflow, we need to change Sign-up to Sign-in
};
export default SignUp;
export { globalUSN, globalPassword };
